import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { Summary } from '@/types/v2/summary/summary'

export const summaryStore = defineStore('v2/summary', () => {
  const loading = ref(false)
  const summary = ref<Summary|null>(null)

  function getSummary () : void {
    loading.value = true
    axios.get(process.env.VUE_APP_API_URL_V2 + '/summary').then((r) => {
      summary.value = r.data
    }).finally(() => {
      loading.value = false
    })
  }

  return {
    loading,
    summary,
    getSummary
  }
})
